import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store';
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { layout: "login" },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: { layout: "login" },
    component: () => import('../views/Register.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/sentimientos_tweeter',
    name: 'Sentimientos Tweeter',
    component: () => import('../views/AnalisisSentimientosTwitter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/processes',
    name: 'Processes',
    component: () => import('../views/process/Processes.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/process/:id',
    name: 'Process',
    props: true,
    component: () => import('../views/process/Process.vue'),
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let token = store.getters['auth/authentication'];
  if (token==""){
    let token_coockie =  Vue.$cookies.get('token');
    let name_coockie =  Vue.$cookies.get('name');
    let profile_pic_coockie =  Vue.$cookies.get('profile_pic');
    let organization_id_coockie =  Vue.$cookies.get('organization_id');
    let rol_id_coockie =  Vue.$cookies.get('rol_id');
    let rol_coockie =  Vue.$cookies.get('rol');
    let organization_coockie =  Vue.$cookies.get('organization');
    store.dispatch('auth/setUser', {
      token:token_coockie,
      nombre:name_coockie,
      profile_pic:profile_pic_coockie,
      organization_id:organization_id_coockie,
      rol_id:rol_id_coockie,
      rol:rol_coockie,
      organization:organization_coockie,
    })
    token=token_coockie
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        name: "Login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }

})

export default router
